import PropTypes from 'prop-types'
import React from 'react'

const BuyCheckboxInput = ({
  label,
  update,
  verify = false,
  classes,
  value,
  spanClasses,
  name,
  labelInside,
  defaultChecked = false,
}) => (
  <label className={verify === false ? `${classes} error` : classes}>
    <input
      data-hj-suppress
      defaultChecked={defaultChecked}
      name={name}
      onChange={update}
      type="checkbox"
      value={value}
    />
    <span className={spanClasses || 'check'}>{labelInside}</span>
    {label}
  </label>
)

BuyCheckboxInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  update: PropTypes.func.isRequired,
  classes: PropTypes.string,
  name: PropTypes.string,
  spanClasses: PropTypes.string,
  verify: PropTypes.bool,
}

export default BuyCheckboxInput
